import React, { useState, useEffect, memo } from "react";
import { Link as ScrollLink } from "react-scroll";
import "../styles/Header.css";

const Header = memo(function Header() {
  const [animate, setAnimate] = useState(false);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimate(true);
    }, 400);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    let ticking = false;
    let heroHeight = 0;

    const heroSection = document.getElementById("hero");
    if (heroSection) {
      heroHeight = heroSection.offsetHeight;
    }

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollPosition = window.scrollY;
          setVisible(scrollPosition < heroHeight - 50);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`custom-header-wrapper 
        ${animate ? "slide-down" : ""}
        ${!visible ? "hide-up" : ""}
      `}
    >
      <header className="custom-header">
        <nav className="custom-nav">
          <ScrollLink to="about" href="#about" smooth={true} duration={500} className="custom-link" spy={true} offset={-70}>About</ScrollLink>
          <ScrollLink to="projects" href="#projects" smooth={true} duration={500} className="custom-link" spy={true} offset={-70}>Projects</ScrollLink>
          <ScrollLink to="contact" href="#contact" smooth={true} duration={500} className="custom-link" spy={true} offset={-70}>Contact</ScrollLink>
        </nav>
      </header>
    </div>
  );
});

export default Header;
